<template>
  <div class="custom-classes-chooser-wrap">
    <template v-if="$scopedSlots.header">
      <div class="header">
        <slot name="header"
              :classes-grades="classesGrades"
              :classes-select="classesSelect"></slot>
      </div>
    </template>
    <div class="main">
      <div class="main-cont"
           v-loading="loading"
           element-loading-text="数据加载中，请稍等...">
        <template v-if="gradeNames && gradeNames.length">
          <CustomClassesChooserGrade class="grade-list"
                                   v-model="gradeName"
                                   :grade-names="gradeNames">
            <template v-for="slot in Object.keys($scopedSlots)"
                      :slot="slot"
                      slot-scope="scope">
              <slot :name="slot" v-bind="scope"></slot>
            </template>
          </CustomClassesChooserGrade>
          <keep-alive>
            <CustomClassesChooserClasses class="classes-list"
                                     :key="gradeName"
                                     v-model="select[gradeName]"
                                     :classes-list="classesList">
              <template v-for="slot in Object.keys($scopedSlots)"
                        :slot="slot"
                        slot-scope="scope">
                <slot :name="slot" v-bind="scope"></slot>
              </template>
            </CustomClassesChooserClasses>
          </keep-alive>
          <CustomClassesChooserCheck class="check-list"
                                   :select="select">
          </CustomClassesChooserCheck>
        </template>
        <template v-else>
          <Hint v-if="!loading">
            <span>班级列表为空</span>
          </Hint>
        </template>
      </div>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="loading"
                 @click="handleApply">确认选择</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
import CustomClassesChooserGrade from './grade'
import CustomClassesChooserClasses from './classes'
import CustomClassesChooserCheck from './check'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'CustomClassesChooserWrap',
  components: {
    CustomClassesChooserGrade,
    CustomClassesChooserClasses,
    CustomClassesChooserCheck,
    Hint
  },
  props: {
    loading: Boolean,
    classesGrades: {
      type: Object,
      required: true
    },
    classesSelect: Object,
    visible: Boolean
  },
  data () {
    return {
      gradeName: '',
      select: {}
    }
  },
  computed: {
    gradeNames () {
      let gradeNames = Object.keys(this.classesGrades)
      gradeNames.sort((o1, o2) => o1 > o2 ? -1 : 1)
      return gradeNames
    },
    classesList () {
      let gradeName = this.gradeName
      if (gradeName) {
        let grade = this.classesGrades[gradeName]
        if (grade) {
          return grade.classesList
        }
      }
    }
  },
  methods: {
    addClassesList (classesList) {
      if (classesList && classesList.length) {
        classesList.forEach(classes => {
          let classesNames = this.select[classes.gradeName] || []
          if (!classesNames.includes(classes.name)) {
            classesNames.push(classes.name)
            this.$set(this.select, classes.gradeName, classesNames)
          }
        })
      }
    },
    removeClassesList (classesList) {
      if (classesList && classesList.length) {
        classesList.forEach(classes => {
          let classesNames = this.select[classes.gradeName]
          if (classesNames && classesNames.length) {
            this.$set(this.select, classes.gradeName, classesNames.filter(c => c !== classes.name))
          }
        })
      }
    },
    handleApply () {
      let select = this.select
      let selectList = []
      Object.values(select).forEach(classesNames => {
        if (classesNames && classesNames.length) {
          selectList = selectList.concat(classesNames)
        }
      })
      this.$emit('select', selectList)
    },
    handleClose () {
      this.$emit('hide')
    },
    initSelect () {
      let classesSelect = this.classesSelect
      if (classesSelect) {
        let keys = Object.keys(classesSelect)
        keys.forEach(key => {
          this.$set(this.select, key, (classesSelect[key] || []).concat())
        })
        Object.keys(this.select).forEach(key => {
          if (!keys.includes(key)) {
            this.select[key] = []
          }
        })
      } else {
        Object.keys(this.select).forEach(key => {
          this.select[key] = []
        })
      }
    }
  },
  watch: {
    gradeName: function (val) {
      if (val) {
        if (!this.select[val]) {
          this.$set(this.select, val, [])
        }
      }
    },
    classesSelect: {
      handler: function () {
        this.initSelect()
      },
      immediate: true
    },
    visible: function (val) {
      if (val) {
        this.initSelect()
      }
    }
  }
}
</script>

<style lang="scss">
  .custom-classes-chooser-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: stretch;
        & > .grade-list {
          flex: 0 0 140px;
          background-color: #fff;
          border-right: 1px solid rgba(0,0,0,.03);
          box-sizing: border-box;
        }
        & > .classes-list {
          flex: auto;
          background-color: #fff;
          border-right: 1px solid #dcdfe6;
          box-sizing: border-box;
          overflow: hidden;
        }
        & > .check-list {
          flex: 0 0 240px;
          overflow: hidden;
        }
        .layout-hint {
          width: 100%;
        }
      }
    }
    & > .footer {
      flex: none;
      background-color: #fff;
      border-top: 1px solid #ebeef5;
      padding: 15px;
      text-align: center;
      .el-button {
        min-width: 90px;
      }
    }
  }
</style>
